<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
    stroke-linejoin="round" width="22" height="22">
    <polyline points="20 6 9 17 4 12" />
  </svg>
</template>

<script>
export default {
  name: 'CheckIcon'
}
</script>
